import React from 'react';
import offlineicon from "../../assets/images/icons/wifi-slash.png";

const DockyardListItem = ({
                              dockyardData,
                              dataUnavailable = false
                          }) => {

    return (
        <div className={`card`}>
            <div className="card-title">
                {dockyardData.name || 'Nom non renseigné'}
            </div>
            <div className="card-body">
                {dockyardData.reference || 'Référence non renseignée'}
            </div>
            {dataUnavailable &&
                <div className="card-footer">
                    <div className={'small-text-left-dark'}>
                        <img className={'icon-offline'} src={offlineicon} alt={"Pas de connexion"}/><span>Contenu indisponible actuellement</span>
                    </div>
                </div>
            }
        </div>
    );
};

export default DockyardListItem;